import {Component, OnInit} from '@angular/core';
import {PageComponent} from '../page.component';
import {ErrorModel} from '../../../model/error.model';
import {HttpStatusCode} from "@angular/common/http";
import {Router} from '@angular/router';

/**
 * @class
 * @component
 * @description This class maintains the page not found component of our application.
 * @export
 * @implements {OnInit}
 * @name NotFoundPageComponent
 */
@Component({
  imports: [
    PageComponent
  ],
  selector: 'app-page-not-found',
  standalone: true,
  styleUrl: './not-found.component.scss',
  templateUrl: './not-found.component.html'
})
export class NotFoundPageComponent implements OnInit {

  /**
   * @description This property contains any errors that occurred during the execution of the page component.
   * @memberof NotFoundPageComponent
   * @name NotFoundPageComponent#error
   * @property
   * @public
   * @type {ErrorModel?}
   */
  public error?: ErrorModel;

  /**
   * @constructor
   * @description This method creates a new instance of the page not found component.
   * @memberof NotFoundPageComponent
   * @name NotFoundPageComponent#constructor
   * @param {Router} router The application router.
   * @public
   */
  public constructor(
    /**
     * @description This property contains the application router.
     * @memberof NotFoundPageComponent
     * @name NotFoundPageComponent#router
     * @private
     * @property
     * @type {Router}
     */
    private router: Router
  ) {
  }

  /**
   * @description This method initializes the component.
   * @memberof PageSignOutComponent
   * @method
   * @name PageSignOutComponent#ngOnInit
   * @public
   * @returns {void}
   */
  public ngOnInit(): void {
    this.error = ErrorModel.fromError(new Error(
      `The page at <strong>${this.router.url}</strong> could not be found.  Please check the URL in the address bar and try again.`
    ), HttpStatusCode.NotFound, 'Page Not Found', 'warning_amber');
  }
}
